export default {
  // Group information
  group: {
    closed: false,
    descriptionHtml: null,
    name: null
  },

  // User's status with regard to the group
  userHasPendingJoinRequest: false,
  userIsGroupMember: false,
  userIsLoggedIn: false,

  // If someone is joining / requesting to join the group, we store the form values here.
  newMember: null,

  // URLs for doing stuff
  groupMembersUrl: null,
  requestToJoinUrl: null,

  // Configuration for the Join or Request To Join form
  notificationLevelOptions: [],
  defaultNotificationLevel: null,
  dataProcessingConsentProps: null,
  joinAdditionalFields: [],
  joinExtraParams: {},
  joinDisclaimerContent: {},
  joinQuestions: []
}
